import { render } from "./progress-circular.vue?vue&type=template&id=08572eb2&lang=pug"
import script from "./progress-circular.vue?vue&type=script&lang=js"
export * from "./progress-circular.vue?vue&type=script&lang=js"
script.render = render

export default script